module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/core-js/modules/_is-object.js
// module id = ../../../../core-js/modules/_is-object.js
// module chunks = polyfills